import { render, staticRenderFns } from "./selfDefenseFireBrigade copy.vue?vue&type=template&id=2155413c"
import script from "./selfDefenseFireBrigade copy.vue?vue&type=script&lang=js"
export * from "./selfDefenseFireBrigade copy.vue?vue&type=script&lang=js"
import style0 from "./selfDefenseFireBrigade copy.vue?vue&type=style&index=0&id=2155413c&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2155413c')) {
      api.createRecord('2155413c', component.options)
    } else {
      api.reload('2155413c', component.options)
    }
    module.hot.accept("./selfDefenseFireBrigade copy.vue?vue&type=template&id=2155413c", function () {
      api.rerender('2155413c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/fft/sdf/selfDefenseFireBrigade copy.vue"
export default component.exports